import React from 'react';
import { View, StyleSheet, Image } from 'react-native';
import { Text } from 'exoflex';
import { insightsLogo } from '../../assets';
// import { logoutIcon } from '../../assets';
import { HEADER } from '../constants/colors';

type Props = {
  title: string;
};

export default function Header(props: Props) {
  let { title } = props;
  return (
    <View style={styles.container}>
      <View style={styles.logoContainer}>
        <Image resizeMode="contain" style={styles.logo} source={insightsLogo} />
      </View>
      <View style={styles.headerContent}>
        <Text weight="medium" style={styles.title}>{`Project ${title}`}</Text>
        {/* <TouchableOpacity style={styles.logoutContainer}>
          <Image
            resizeMode="contain"
            style={styles.logoutIcon}
            source={logoutIcon}
          />
          <Text weight="medium">Logout</Text>
        </TouchableOpacity> */}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    minHeight: 70,
    flexDirection: 'row',
    borderRadius: 12,
    shadowColor: HEADER.shadow,
    shadowOpacity: 0.5,
    shadowRadius: 12,
    shadowOffset: {
      height: 4,
      width: 0,
    },
  },
  logoContainer: {
    flex: 1,
    paddingVertical: 20,
    paddingHorizontal: 36,
    borderRightWidth: 2,
    borderRightColor: HEADER.borderLogo,
  },
  headerContent: {
    flex: 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 24,
    paddingRight: 36,
  },
  logo: {
    width: '100%',
    height: '100%',
  },
  logoutContainer: {
    flexDirection: 'row',
  },
  logoutIcon: {
    width: 20,
    height: 20,
    marginRight: 12,
  },
  title: {
    fontSize: 18,
  },
});
